import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import Datepicker from "components/DatePicker/DatePicker";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Textbox } from "components/Textbox/Textbox";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { trans } from "utils/helpers";

interface GuaranteeFormProps {
  response?: any;
  mode?: any;
  sourceDataParam?: any;
  SourceData?: any;
  setResponse?: any;
  sendDataForCalcAsync?: any;
  contractConstraint?: any;
}
export const GuaranteeForm = forwardRef(
  (
    {
      response,
      mode,
      sourceDataParam,
      SourceData,
      contractConstraint,
    }: GuaranteeFormProps,
    ref: any
  ) => {
    const [resetForm, setResetForm] = useState(false);
    const formRef = useRef<any>();
    const [guaranteeStartDate, setGuaranteeStartDate] = useState<any>();
    const [guaranteeEndDate, setGuaranteeEndDate] = useState<any>();
    const [editor, setEditor] = useState<any>();
    const [editorData, setEditorData] = useState<any>(
      response?.GuaranteeConditions
    );
    const [editorEN, setEditorEN] = useState<any>();
    const [editorDataEN, setEditorDataEN] = useState<any>(
      response?.GuaranteeConditionsEN
    );
    const [conditionsLang, setConditionsLang] = useState("fa");
    const [userChanges, setUserChanges] = useState({});

    const [customerInfo, setCustomerInfo] = useState<any>(null);
    const [customer, setCustomer] = useState<any>(null);

    const [todayDate, settodayDate] = useState<any>(new Date().toISOString());
    const [salesContractNo, setSalesContractNo] = useState<any>(false);
    const contractRef = useRef<any>(null);

    const [requiredFields, setRequiredFields] = useState<any>();

    useImperativeHandle(ref, () => ({
      getAllData() {
        if (!formRef.current.reportValidity()) {
          return false;
        } else {
          return {
            GuaranteeStartDate: guaranteeStartDate,
            GuaranteeEndDate: guaranteeEndDate,
            GuaranteeConditions: editorData,
            GuaranteeConditionsEN: contractConstraint?.ShowENFields
              ? editorDataEN
              : null,
            GuaranteeDocuments: formRef.current.GuaranteeDocuments.value,
            GuaranteeDocumentsEN: contractConstraint?.ShowENFields
              ? formRef.current.GuaranteeDocumentsEN.value
              : null,
            GuaranteeValue: +formRef.current.GuaranteeValue.value,
          };
        }
      },
    }));
    return (
      <div>
        <form
          ref={formRef}
          // onSubmit={handlesalesContractDetailFormSubmit}
        >
          <FormWithTitle
            title={trans("guarantee")}
            defualtClose={true}
            showFristRow={true}
            closeOption={true}
            dynamicTitle={{
              CustomerName: customer?.Name,


              ...(response?.JobNo && { JobNo: response?.JobNo }),
              ...(salesContractNo && { salesContractno: salesContractNo })
            }}
          >
            <div className="card-body" style={{paddingTop:'1px'}}>
              <div className="row ">
                <div className="col-lg-1 col-11">
                  <Datepicker
                    mode={
                      contractConstraint.IsNewDocCurrentDate ? "view" : mode
                    }
                    lable="GuaranteeStartDate"
                    setIsoTime={(isoTime: string) => {
                      setGuaranteeStartDate(isoTime);
                    }}
       
                    val={
                      response
                        ? response.GuaranteeStartDate
                        : contractConstraint.IsNewDocCurrentDate
                        ? todayDate
                        : null
                    }
                    errorFlag={false}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                  />
                </div>

                <div className="col-lg-1 col-11">
                  <Datepicker
                    mode={
                      contractConstraint.IsNewDocCurrentDate ? "view" : mode
                    }
                    lable="GuaranteeEndDate"
                    setIsoTime={(isoTime: string) => {
                      setGuaranteeEndDate(isoTime);
                    }}
                    val={
                      response
                        ? response.GuaranteeEndDate
                        : contractConstraint.IsNewDocCurrentDate
                        ? todayDate
                        : null
                    }
                    errorFlag={false}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="GuaranteeDocuments"
                    textboxType="text"
                    labelText="GuaranteeDocuments"
                    defaultValue={response?.GuaranteeDocuments}
                    resetForm={resetForm}
                    mode={mode}
                    required={requiredFields?.GuaranteeDocuments}
                  />
                </div>
                {contractConstraint?.ShowENFields && (
                  <div className="col-lg-3 col-11">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="GuaranteeDocumentsEN"
                      textboxType="text"
                      labelText="GuaranteeDocumentsEN"
                      defaultValue={response?.GuaranteeDocumentsEN}
                      resetForm={resetForm}
                      mode={mode}
                      required={requiredFields?.GuaranteeDocumentsEN}
                    />
                  </div>
                )}
                <div className="col-lg-3 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="GuaranteeValue"
                    textboxType="number"
                    labelText="GuaranteeValue"
                    defaultValue={response?.GuaranteeValue}
                    resetForm={resetForm}
                    mode={mode}
                  />
                </div>
                <div className="w-100"></div>

                {contractConstraint?.ShowENFields && (
                  <div className="col-8 row mb-2">
                    <div className="col-6 my-1 my-lg-0 col-lg-4">
                      <CheckableButton
                        onchange={() => setConditionsLang("fa")}
                        type="radio"
                        labelText="GuaranteeConditions"
                        defaultChecked={conditionsLang == "fa"}
                        defaultValue={conditionsLang == "fa"}
                        value={conditionsLang == "fa"}
                        inputName="conditionsLang"
                        mode={mode}
                      />
                    </div>
                    <div className="col-6 my-1 my-lg-0 col-lg-4">
                      <CheckableButton
                        onchange={() => setConditionsLang("en")}
                        type="radio"
                        labelText="GuaranteeConditionsEN"
                        defaultChecked={conditionsLang == "en"}
                        defaultValue={conditionsLang == "en"}
                        value={conditionsLang == "en"}
                        inputName="conditionsLang"
                        mode={mode}
                      />
                    </div>
                  </div>
                )}

                {(!contractConstraint?.ShowENFields ||
                  (contractConstraint?.ShowENFields &&
                    conditionsLang == "fa")) && (
                  <div className="col-12 mb-3">
                    <span>{trans("GuaranteeConditions")}</span>
                    <CKEditor
                      data={editorData}
                      disabled={mode == "view" && "true"}
                      onReady={(editor) => {
                        editor.ui
                          .getEditableElement()
                          .parentElement.insertBefore(
                            editor.ui.view.toolbar.element,
                            editor.ui.getEditableElement()
                          );
                        setEditor(editor);
                      }}
                      onError={(error, { willEditorRestart }) => {
                        if (willEditorRestart) {
                          editor.ui.view.toolbar.element.remove();
                        }
                      }}
                      onOk={(editor) => {
                        editor.insertHtml(editorData);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setEditorData(data);
                      }}
                      editor={DecoupledEditor}
                      config={{
                        removePlugins: [
                          "EasyImage",
                          "ImageUpload",
                          "MediaEmbed",
                        ],
                      }}
                    />
                  </div>
                )}

                {contractConstraint?.ShowENFields && conditionsLang == "en" && (
                  <div className="col-12 mb-3">
                    <span>{trans("GuaranteeConditionsEN")}</span>
                    <CKEditor
                      data={editorDataEN}
                      disabled={mode == "view" && "true"}
                      onReady={(editor) => {
                        editor.ui
                          .getEditableElement()
                          .parentElement.insertBefore(
                            editor.ui.view.toolbar.element,
                            editor.ui.getEditableElement()
                          );
                        setEditorEN(editor);
                      }}
                      onError={(error, { willEditorRestart }) => {
                        if (willEditorRestart) {
                          editorEN.ui.view.toolbar.element.remove();
                        }
                      }}
                      onOk={(editor) => {
                        editor.insertHtml(editorDataEN);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setEditorDataEN(data);
                      }}
                      editor={DecoupledEditor}
                      config={{
                        removePlugins: [
                          "EasyImage",
                          "ImageUpload",
                          "MediaEmbed",
                        ],
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </FormWithTitle>
        </form>
      </div>
    );
  }
);
